import { render, staticRenderFns } from "./AssignWordModal.vue?vue&type=template&id=8ff69384&scoped=true&"
import script from "./AssignWordModal.vue?vue&type=script&lang=js&"
export * from "./AssignWordModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff69384",
  null
  
)

export default component.exports